{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.suedburgenland.softline",
  "name": "Softline Suedburgenland"
}
